import React, { Suspense } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import Configuration from './components/config';
import DeleteTemplate from './components/DeleteTemplateModule/deleteTemplateModule';
import ViewUpdate from './components/ViewUpdateTaskModule/viewUpdateTaskModule';
import NewMessage from './components/NewMessage/newMessage';
import StatusTaskModule from './components/StatusTaskModule/statusTaskModule';
import './App.scss';
import SendConfirmationTaskModule from './components/SendConfirmationTaskModule/sendConfirmationTaskModule';
import VideoPlayerTaskModule from './components/VideoPlayerTaskModule/videoPlayerTaskModule';
import { app } from "@microsoft/teams-js";
import ErrorPage from "./components/ErrorPage/errorPage";
import SignInPage from "./components/SignInPage/signInPage";
import SignInSimpleStart from './components/SignInPage/signInSimpleStart';
import SignInSimpleEnd from './components/SignInPage/signInSimpleEnd';
import CommsCalender from './components/Calendar/calendar';
import HomePage from './components/CommunicatorContainer/communicatorContainer';
import { updateLocale } from './i18n';
import Initializer from './Initializer';
import { FluentProvider, teamsHighContrastTheme, teamsDarkTheme, teamsLightTheme } from '@fluentui/react-components'

export interface IAppState {
  theme: string;
}

class App extends React.Component<{}, IAppState> {

  constructor(props: {}) {
    super(props);
    this.state = {
      theme: "",
    }
  }

  public componentDidMount() {
    app.initialize().then(() =>{
      app.getContext().then((context: app.Context) => {
        let theme = context.app.theme || "";
        this.setState({
          theme: theme
        });
      });
  
      app.registerOnThemeChangeHandler((theme) => {
            this.setState({
              theme: theme,
            }, () => {
              this.forceUpdate();
            });
      });
    });
    
    updateLocale();
  }

  public setThemeComponent = () => {
    if (this.state.theme === "dark") {
      return (
        <FluentProvider theme={teamsDarkTheme}>
          <div className="darkContainer">
            {this.getAppDom()}
          </div>
        </FluentProvider>
      );
    }
    else if (this.state.theme === "contrast") {
      return (
        <FluentProvider theme={teamsHighContrastTheme}>
          <div className="highContrastContainer">
            {this.getAppDom()}
          </div>
        </FluentProvider>
      );
    } else {
      return (
        <FluentProvider theme={teamsLightTheme}>
          <div className="defaultContainer">
            {this.getAppDom()}
          </div>
        </FluentProvider>
      );
    }
  }

  public getAppDom = () => {
    return (
      <>
        <Initializer />
        <Suspense fallback={<div></div>}>
          <div className="appContainer">
            <BrowserRouter>
              <Switch>
                <Route exact path="/configtab" component={Configuration} />
                <Route exact path="/homepage" component={HomePage} />
                <Route exact path="/deletetemplate/:id" component={DeleteTemplate} />
                <Route exact path="/messages" component={HomePage} />
                <Route exact path="/newmessage" component={NewMessage} />
                <Route exact path="/viewupdates" component={ViewUpdate} />
                <Route exact path="/newmessage/:id" component={NewMessage} />
                <Route exact path="/newmessage/:messagetype/:id" component={NewMessage} />
                <Route exact path="/newmessage/:date" component={NewMessage} />
                <Route exact path="/viewstatus/:id" component={StatusTaskModule} />
                <Route exact path="/viewvideo" component={VideoPlayerTaskModule} />
                <Route exact path="/sendconfirmation/:id" component={SendConfirmationTaskModule} />
                <Route exact path="/errorpage" component={ErrorPage} />
                <Route exact path="/errorpage/:id" component={ErrorPage} />
                <Route exact path="/signin" component={SignInPage} />
                <Route exact path="/signin-simple-start" component={SignInSimpleStart} />
                <Route exact path="/signin-simple-end" component={SignInSimpleEnd} />
                <Route exact path="/commsCalendar" component={CommsCalender} />
              </Switch>
            </BrowserRouter>
          </div>
        </Suspense>
        </>
    );
  }

  public render(): JSX.Element {
    return (
      <div>
        {this.setThemeComponent()}
      </div>
    );
  }
}

export default App;